import { render, staticRenderFns } from "./date-picker-type-editor.vue?vue&type=template&id=24b9a43e&scoped=true"
import script from "./date-picker-type-editor.vue?vue&type=script&lang=js"
export * from "./date-picker-type-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9a43e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b9a43e')) {
      api.createRecord('24b9a43e', component.options)
    } else {
      api.reload('24b9a43e', component.options)
    }
    module.hot.accept("./date-picker-type-editor.vue?vue&type=template&id=24b9a43e&scoped=true", function () {
      api.rerender('24b9a43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-date-picker/date-picker-type-editor.vue"
export default component.exports